import { createContext, useContext } from 'react';
import type { Chain } from 'viem';
import type { Connector, CreateConnectorFn } from 'wagmi';

import type { AmountInput } from '#src/__generated__/globalTypes.ts';

import type { DepositAction } from './types.ts';
import type { PendingDeposits } from './useCreatePendingDeposit.ts';

type BlockchainContext = {
  loading: boolean;
  activeConnector: Connector | undefined;
  isConnected: boolean;
  wrongChain: boolean;
  /** Connected address from connector (wallet extension). */
  ethAddress: EthereumAddress | undefined;
  depositEth: (amountInWei: bigint) => Promise<null | {
    result?: EthereumAddress | null;
    err?: Error;
  }>;
  depositBaseBankEth: (amountInWei: bigint) => Promise<null | {
    result?: EthereumAddress | null;
    err?: Error;
  }>;
  depositNft: (
    contractAddress: EthereumAddress,
    assetId: string
  ) => Promise<null | {
    err?: Error;
    txHash?: string;
    type?: DepositAction;
  }>;
  connectToEthereum: (connector: CreateConnectorFn | Connector) => void;
  disconnect: () => void;
  setupWalletConnect: () => Promise<void>;
  setupCoinbaseWallet: () => Promise<void>;
  setupOpera: () => Promise<void>;
  connectors: readonly Connector[];
  ethereumNetworkId?: string;
  expectedEthereumNetwork?: Chain;
  reset: () => void;
  createPendingDeposit: (
    transactionHash: string,
    amount: AmountInput
  ) => Promise<PendingDeposits | undefined>;
};

export const BlockchainContext = createContext<BlockchainContext | null>(null);

export const useBlockchainContext = () => useContext(BlockchainContext)!;
